import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& .icon': {
      width: '1rem',
      height: '1rem',
      color: theme.palette.primary.main,
      cursor: 'pointer'
    }
  }
}))

export default useStyles
